


import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import FormComponent from './form/Form.vue';

import LoaderComponent from '@/shared/components/Loader.vue';
import ErrorMessagesComponent from "@/shared/components/ErrorMessages.vue";

import HttpService from "@/shared/services/http-service";
import UserProfileService from "../services/user-profile-service";
import CountryService from "../services/country-service";

@Component({
  components: {
    FormComponent,
    LoaderComponent,
    ErrorMessagesComponent
  },
  computed: {
    ...mapGetters(["loading", "config", "error", "profileData"])
  },
})
export default class UserProfileComponent extends Vue {
  @Prop() configRaw!: string;

  mounted() {
      this.init();
  }

  private init(): void {
      this.startup();
  }

  private startup(): void {
      try {
          this.$store.commit("setConfig", this.configRaw);
          this.loadData();
      } catch (error) {
          console.error(error);
          this.$store.commit('setError', this.getErrorText())
          this.$store.commit("setLoading", false);
      }
  } 

  private loadData(): void {
      Promise.all([
          UserProfileService.getUserProfile(this.$store.getters.config, HttpService),
          CountryService.getCountries(this.$store.getters.config, HttpService)
      ])
      .then(values => {
          this.$store.commit("setProfileData", values[0]);
          this.$store.commit("setCountries", values[1]);
      })
      .catch((error) => {
          console.error(error);
          this.$store.commit('setError', this.getErrorText())
      })
      .finally(() => this.$store.commit("setLoading", false));
  }

  private getErrorText(): string {
    return this.$store.getters.config.language.toLowerCase() === "nl"
      ? "Er gaat iets fout, probeer het later nog een keer"
      : "Something went wrong, please try again later";
  }
}
